import { Card, CardContent, CardHeader, CardTitle } from '@bill-alps/ui';

/**
 * Placeholder shown while the recharts-backed `DashboardChartCard` chunk loads.
 * Mirrors the real card's header and `h-60` plot area so the dashboard doesn't
 * shift when the chart arrives.
 */
export function DashboardChartCardSkeleton({ title }: { title: string }) {
  return (
    <Card static>
      <CardHeader className="pb-2">
        <div className="flex items-center justify-between gap-2">
          <CardTitle className="text-sm font-semibold">{title}</CardTitle>
        </div>
      </CardHeader>
      <CardContent>
        <div className="h-60 w-full animate-pulse rounded-md bg-muted/40" />
      </CardContent>
    </Card>
  );
}
